<form [formGroup]="form" class="form-app-preferences" (click)="onTouched()">
  <div class="text-container">
    <div>
      @if (showInfo) {
        <ion-label class="title">{{ 'onboarding.company.info' | transloco }}</ion-label>
      }
      @if (isReadOnly) {
        <div class="flex-column gap-8">
          <c-label-value [label]="'onboarding.company.name' | transloco" [value]="form.value.name" />
          @if (form.value.companyNumber) {
            <c-label-value [label]="'onboarding.company.coc-number' | transloco" [value]="form.value.companyNumber" />
          }
          @if (form.value.vatNumber) {
            <c-label-value [label]="'onboarding.company.vat-number' | transloco" [value]="form.value.vatNumber" />
          }
        </div>
      } @else {
        <div class="form-stack">
          <c-input [label]="'onboarding.company.name' | transloco" formControlName="name" />
          <c-input [label]="'onboarding.company.coc-number' | transloco" formControlName="companyNumber" />
          <c-input [label]="'onboarding.company.vat-number' | transloco" formControlName="vatNumber" />
        </div>
      }
    </div>
  </div>
</form>
